import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/logoMBF.png'


const _hoisted_1 = { class: "grid min-h-full place-items-center overflow-y-auto bg-[linear-gradient(135deg,#062b63,#0d63c7_48%,#f5f9fd_48%)] p-4" }
const _hoisted_2 = { class: "grid w-full max-w-5xl overflow-hidden rounded-[28px] bg-white shadow-2xl md:grid-cols-[1.05fr_0.95fr]" }
const _hoisted_3 = { class: "mt-20 space-y-4" }
const _hoisted_4 = {
  key: 0,
  class: "rounded-xl bg-rose-50 px-3 py-2 text-sm font-medium text-rose-700"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiInput = _resolveComponent("UiInput")!
  const _component_UiButton = _resolveComponent("UiButton")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"relative hidden min-h-[620px] bg-brand-900 p-8 text-white md:block\"><div class=\"absolute inset-0 bg-[radial-gradient(circle_at_24%_20%,rgba(255,255,255,0.22),transparent_28%),linear-gradient(150deg,rgba(31,122,224,0.55),transparent_48%)]\"></div><div class=\"relative z-10 flex h-full flex-col justify-between\"><div class=\"flex items-center gap-3\"><div><p class=\"text-2xl font-black\">Quản lý tài sản</p></div></div><div><p class=\"mb-4 text-lg font-semibold text-blue-100\"> Dashboard vận hành </p><h2 class=\"max-w-md text-4xl font-black leading-tight\"> Theo dõi thiết bị, bàn giao và xuất báo cáo. </h2></div><div class=\"grid grid-cols-3 gap-3 text-center\"><div class=\"rounded-2xl bg-white/10 p-4 backdrop-blur\"><p class=\"text-2xl font-black\">01</p><p class=\"text-xs text-blue-100\">Tài sản</p></div><div class=\"rounded-2xl bg-white/10 p-4 backdrop-blur\"><p class=\"text-2xl font-black\">02</p><p class=\"text-xs text-blue-100\">Bàn giao</p></div><div class=\"rounded-2xl bg-white/10 p-4 backdrop-blur\"><p class=\"text-2xl font-black\">03</p><p class=\"text-xs text-blue-100\">Báo cáo</p></div></div></div></div>", 1)),
      _createElementVNode("form", {
        class: "p-6 sm:p-10",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => ($setup.doLogin && $setup.doLogin(...args)), ["prevent"]))
      }, [
        _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"mb-8 flex items-center gap-3 md:hidden\"><img src=\"" + _imports_0 + "\" alt=\"MBF\" class=\"h-12 w-12 rounded-2xl object-contain\"><div><p class=\"text-xs font-semibold uppercase tracking-[0.2em] text-brand-600\"> Mobifone </p><p class=\"text-xl font-black text-ink\">Quản lý tài sản</p></div></div><p class=\"text-sm font-semibold uppercase tracking-[0.2em] text-brand-600\"> Đăng nhập </p><p class=\"mt-2 text-2xl font-bold text-ink\">Chào mừng trở lại</p><p class=\"mt-2 text-sm text-slate-500\"> Nhập thông tin tài khoản để tiếp tục vào dashboard. </p>", 4)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _cache[3] || (_cache[3] = _createElementVNode("label", { class: "label" }, "Tên đăng nhập", -1)),
            _createVNode(_component_UiInput, {
              modelValue: $setup.userName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.userName) = $event)),
              class: "h-12",
              autocomplete: "username",
              placeholder: "Nhập tên đăng nhập"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _cache[4] || (_cache[4] = _createElementVNode("label", { class: "label" }, "Mật khẩu", -1)),
            _createVNode(_component_UiInput, {
              modelValue: $setup.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.password) = $event)),
              class: "h-12",
              type: "password",
              autocomplete: "current-password",
              placeholder: "Nhập mật khẩu"
            }, null, 8, ["modelValue"])
          ]),
          ($setup.errorMessage)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString($setup.errorMessage), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_UiButton, {
            type: "submit",
            icon: "login",
            variant: "primary",
            size: "lg",
            block: "",
            disabled: !$setup.valid,
            loading: $setup.loading,
            "loading-text": "Đang đăng nhập..."
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.loading ? "Đang đăng nhập..." : "Đăng nhập"), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading"])
        ])
      ], 32)
    ])
  ]))
}